import { Component } from 'react';

import { FlashMessage as OCFlashMessage } from '@openclassrooms/ui-web/notifications';

import { translate } from '@openclassrooms/translations';

/**
 * @deprecated
 * ### Description
 * `Snackbar` has been deprecated and replaced by Classify `Snackbar`.
 *
 * ### Example
 * ```
 * import Snackbar from '@classify/react-core-components/Snackbar';
 * ```
 */
class FlashMessage extends Component {
  static defaultProps = {
    htmlContent: '',
    status: 'default',
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
  }

  handleClose = () => {
    this.setState(() => ({ isOpen: false }));
  };

  render() {
    const { status, htmlContent } = this.props;
    const { isOpen } = this.state;

    const content = {
      __html: htmlContent,
    };

    return (
      <OCFlashMessage
        autoCloseDuration={5000}
        canShowCloseButtonOnAutoClose
        isOpen={isOpen}
        onClose={this.handleClose}
        status={status}
        translations={{ close: translate('global.action.close_button') }}
      >
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={content} />
      </OCFlashMessage>
    );
  }
}

export default FlashMessage;
